import LeanAPI from '@/api/lean'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  async fetchSessionData(_, sessionId) {
    const { data, header } = await LeanAPI.fetchLeanSession(sessionId)

    return { data, header }
  },
  async logUserAction(_, { sessionId, event }) {
    const { data, header } = await LeanAPI.logUserAction(sessionId, event)

    return { data, header }
  },
  async fetchLinkStatus(_, sessionId) {
    const { data, header } = await LeanAPI.fetchLinkStatus(sessionId)

    return { data, header }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
